import clsx from 'clsx';
import { Icon } from 'common/icon';
import { Routes } from 'constants/routes';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.css';

import { useRouter } from 'next/router';
import { useDebounce } from 'usehooks-ts';
import { syncShallowSearchUrl } from 'utils/search-query';
// import { RegionsModal } from 'components/modal/regions';
import { Footer } from './footer';
import { Tag } from './tag';
import { MenuItemProps } from 'constants/types';
import { ResultSearch } from 'components/menu-footer/result-search';

export const MenuItem = ({ icon, label, url = '', tagText }: MenuItemProps) => {
  if (!url?.length) {
    return (
      <div className={styles.menuItem_container}>
        <li className={clsx(styles.menuItem, styles.menuItemNoHover)}>
          {icon && icon}
          <span className={styles.menuLabel}>{label}</span>
          {tagText && <Tag text={tagText} />}
        </li>
      </div>
    );
  }

  return (
    <div className={styles.menuItem_container}>
      <li className={styles.menuItem}>
        <Link prefetch={false} className={styles.menuItemLink} href={url}>
          {icon && icon}
          <span className={styles.menuLabel}>{label}</span>
          {tagText && <Tag text={tagText} />}
        </Link>
      </li>
    </div>
  );
};

const menuItems: MenuItemProps[] = [
  {
    icon: <Icon.Figure />,
    label: 'Casinos',
    url: Routes.allCasinos,
  },
  {
    icon: <Icon.Dollar />,
    label: 'Slots',
    url: Routes.allSlots,
  },
  {
    icon: <Icon.NewsSecond />,
    label: 'Blog and news',
    url: Routes.blogAndNews,
  },
  {
    icon: <Icon.Book />,
    label: 'Guides',
    url: Routes.guides,
    tagText: 'NEW',
  },
  {
    icon: <Icon.Complaints />,
    label: 'Complaints',
    url: Routes.complaints,
  },
  {
    icon: <Icon.MessageFourth width="20px" height="20px" />,
    label: 'Topics',
    url: Routes.questions,
  },
  {
    icon: <Icon.AlignLeft />,
    label: 'About Us',
    url: Routes.aboutUs,
  },
];

const Header = () => {
  const router = useRouter();
  const isMain = router.pathname === '/';

  const headerClass = clsx(styles.header, { [styles.default_cursor]: isMain });
  return isMain ? (
    <div className={headerClass}>
      <Icon.Logo />
    </div>
  ) : (
    <Link href={Routes.home} className={headerClass}>
      <Icon.Logo />
    </Link>
  );
};

export const SearchBar = () => {
  const router = useRouter();
  const search = router.query.q1
    ? String(decodeURIComponent(router.query.q1?.toString()))
    : '';
  const searchRef = useRef<HTMLInputElement | null>(null);
  const [filter, setFilter] = useState('');
  const containerRef = useRef<HTMLDivElement | null>(null);
  const debounceValue = useDebounce(filter, 500);

  useEffect(() => {
    if (search) {
      setFilter(search);
      searchRef.current?.focus();
    }
  }, [search]);

  useEffect(() => {
    syncShallowSearchUrl(router, Routes.home, debounceValue, 'q1');
  }, [debounceValue, router]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const searchUrl = `${Routes.search}?q2=${encodeURIComponent(filter)}`;
      router.push(searchUrl);
    }
  };
  return (
    <>
      <div ref={containerRef}>
        <div className={styles.searchBar}>
          <div className={styles.iconContainer}>
            <div className={styles.searchIcon} />
            <input
              type="text"
              value={filter}
              ref={searchRef}
              className={styles.searchInput}
              onChange={(e) => setFilter(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder={'Check casino...'}
            />
          </div>
          {(filter.length || search?.length) && (
            <button
              onClick={() => {
                setFilter('');
                searchRef.current?.focus();
              }}
              className={styles.clearContainer}
            >
              <Icon.Close height={20} width={20} />
            </button>
          )}
        </div>
        <div className={styles.result_search__container}>
          <ResultSearch
            variant={'sidebar'}
            searchRef={searchRef}
            searchText={debounceValue}
            containerRef={containerRef}
          />
        </div>
      </div>
    </>
  );
};

const MenuRow = ({ items }: menuRowProps) => {
  return (
    <div className={styles.menuRow}>
      {items.map((item: MenuItemProps, index: number) => (
        <MenuItem
          key={index}
          label={item.label}
          url={item.url}
          icon={item.icon}
          tagText={item.tagText}
        />
      ))}
    </div>
  );
};

export const MenuMobile = () => {
  return (
    <div className={styles.menuContainer}>
      <div className={styles.regionsButtonContainer}>
        {/* <RegionsModal /> */}
      </div>
      <div className={styles.menuGroup}>
        <MenuRow items={[menuItems[5], menuItems[6]]} />
        <MenuRow items={menuItems.slice(3, 5)} />
        <MenuRow items={menuItems.slice(0, 3)} />
      </div>
    </div>
  );
};

interface menuRowProps {
  items: MenuItemProps[];
}

export const SidebarMenu = () => {
  return (
    <aside>
      <div className={styles.sidebarMenuShadow} />
      <div className={styles.sidebarMenuContainer}>
        <div className={styles.sidebarMenu}>
          <div className={styles.header_regions}>
            <Header />
            {/* <RegionsModal useSlug /> */}
          </div>
          <SearchBar />
          <ul className={styles.menuList}>
            {menuItems.map((item, index) => (
              <MenuItem
                key={index}
                icon={item.icon}
                label={item.label}
                url={item.url}
                tagText={item.tagText}
              />
            ))}
          </ul>
        </div>
        <Footer />
      </div>
    </aside>
  );
};
